<template>
  <div class="grid grid-cols-1 lg:grid-cols-detail m-4 md:mx-8 md:mt-16 gap-8">
    <section class="w-full rounded">
      <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
        <h2>{{ $t("lang.msg.warehouseData") }}</h2>
      </div>
      <form class="bg-white p-4 space-y-4 rounded-b">
        <InputWrapper :label="$t('lang.fields.name')" content="input" block>
          <InputText v-model="newItem.warehouseName" :name="$t('lang.fields.name')" />
        </InputWrapper>
        <InputWrapper :label="$t('lang.fields.address')" content="input" block>
          <textarea
            v-model="newItem.warehouseAdress"
            :placeholder="$t('lang.fields.address')"
            class="form-textarea w-full pr-6"
          />
        </InputWrapper>
        <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
          <InputText v-model="newItem.warehousePhone" :name="$t('lang.fields.phone')" />
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.clients')" content="input" block>
          <multiselect
            v-model="newItem.clients"
            :options="clients"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :taggable="true"
            tag-placeholder="Escriba para añadir un cliente"
            placeholder="Escriba para buscar clientes"
            label="clientName"
            track-by="idClient"
            select-label="Pulse enter para seleccionar"
            deselect-label="Pulse enter para eliminar"
            @select="storeClient"
            @remove="removeClient"
          />
        </InputWrapper>
        <AdminToggleButton v-model="newItem.active" />

        <span class="flex w-full rounded-md shadow-sm sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-primario hover:bg-primario text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="addOrEditItem(`api/Warehouses/Add`, `api/Warehouses/Update`, () => {})"
          >{{ newItem.idFactory == undefined ? $t('lang.msg.save') : $t('lang.msg.update') }}</button>
        </span>
      </form>
    </section>

    <div class="flex flex-col w-full space-y-8">
      <section>
        <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
          <h2>EMAILS</h2>
        </div>
        <div class="bg-white px-4 pb-2 rounded-b">
          <div
            v-for="(item, index) in emails"
            :key="`item_${index}`"
            class="py-2 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-emails gap-2 items-end"
          >
            <InputWrapper :label="$t('lang.fields.email')" content="input" block>
              <InputText v-model="item.email" name="nombre@dominio.com" />
            </InputWrapper>
            <div class="flex justify-between">
              <div class="flex space-x-2">
                <div class="flex space-x-2" v-if="emails.length > 1 && item.idContactPerson">
                  <ButtonRounded @action="removeEmail(index)" color="red">
                    <IconRemove />
                  </ButtonRounded>

                  <ButtonRounded @action="updateEmail(item)" color="green">
                    <IconUpdate />
                  </ButtonRounded>
                </div>
                <ButtonRounded v-if="index == emails.length - 1" @action="addNewEmail(item)" color="blue">
                  <IconAdd />
                </ButtonRounded>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import UtilsMixin from "@/components/mixins/UtilsMixin";
import AdminMixin from "@/components/mixins/AdminMixin";
import Multiselect from "vue-multiselect";

export default {
  name: "WarehouseDetail",
  mixins: [UtilsMixin, AdminMixin],
  components: {
    Multiselect
  },
  data() {
    return {
      idWarehouse: 0,
      emails: [{}]
    }
  },
  created() {
    if (this.$route.params.idWarehouse) {
      this.idWarehouse = parseInt(this.$route.params.idWarehouse);
      this.isEditing = true;

      this.fetchOneWarehouse();
    }

    this.fetchClients();
  },
  methods: {
    fetchOneWarehouse() {
      this.$axios.post("api/Warehouses/GetThisWarehouse", {
        idWarehouse: this.idWarehouse  
      }).then((response) => {
        this.newItem = response.data[0] || {};

        this.fetchEmails();
        this.fetchWarehouseClients();
      });
    },
    fetchWarehouseClients() {
      this.$axios.post("api/Warehouses/GetClientWarehouse", {
        idWarehouse: this.idWarehouse
      }).then((response) => {
        this.$set(this.newItem, 'clients', response.data);
      });
    },
    fetchEmails() {
      this.$axios.post("api/ContactPersons/PostSearchWarehouse", {
        idWarehouse: this.idWarehouse
      }).then((response) => {
        // At least 1 empty Email exist in the array.
        response.data.push({});

        this.emails = response.data;
      });
    },
    addNewEmail(item) {
      item.idWarehouse = this.idWarehouse;
      if (item.email) {
        this.$axios.post(`api/ContactPersons/Add`, item).then(() => {
          this.fetchEmails();
          this.emails.push({});
          this.openAlert('success', 'Correo electrónico añadido', null);
        });
      } else {
        this.openAlert('info', 'Rellene correctamente el formulario', null);
      }
    },
    updateEmail(item) {
      item.idWarehouse = this.idWarehouse;
      this.$axios.post(`api/ContactPersons/Update`, item).then(() => {
        this.openAlert('success', 'Correo electrónico actualizado', null);
      });
    },
    removeEmail(index) {
      this.$axios.post(`api/ContactPersons/Delete`, this.emails[index]).then(() => {
        this.openAlert('success', 'Correo electrónico eliminado', null);
      });
      
      this.emails.splice(index, 1);
    },
    storeClient(item) {
      this.$axios.post(`api/Warehouses/AddClient`, {
        idClient: item.idClient,
        idWarehouse: this.idWarehouse
      }).then(() => {
        this.fetchWarehouseClients();
      });
    },
    removeClient(item) {
      this.$axios.post(`api/Warehouses/DeleteClientWarehouse`, item);
    }
  }
}
</script>